module.exports = __webpack_public_path__ + "img/c03_unitstonethrower_Normal_ua.f8eda0fe.webp";